import React from 'react';
import { Box, ResponsiveValue } from '@chakra-ui/react';
import { MainHeader } from '../molecules/MainHeader';
import { SubHeader } from '../molecules/SubHeader';

// Define props interface
interface HeaderProps {
  logoUrl: string; // URL for the logo
  gameTitle: string; // Title of the game
  platforms: string[]; // List of platforms
  supportedLanguages?: { label: string; value: string }[];
  currentLanguage: string; // Current selected language
  onLanguageChange: (language: string) => void; // Handler for language change
  onClickMyTickets: () => void;
  horizontalPadding?: ResponsiveValue<string>; // Optional horizontal padding
  showHeader?: boolean;
  showMainHeader?: boolean;
  showSubHeader?: boolean;
  showHeaderLogo?: boolean;
  mainHeaderBgColor: string;
  subHeaderBgColor: string;
  subHeaderTextColor: string;
  mainHeaderTextColor: string;
  changeTheme?: () => void;
  myTicketsButtonText: string;
  loginButtonText: string;
  logoWidth?: { base: string; lg: string };
  onClickLandingPageButton?: () => void;
  // targetUrl?: string;
  secondaryAccentColor: string;
  headerTextColors: string;
  onButtonClick?: () => void;
  color?: string;
  buttonBgColor?: string;
  contactUsButtonText?: string;
  unreadMessageCount?: number;
  myTicketsHref?: () => string | undefined;
  landingPageHref?: () => string | undefined;
  contactUsHref?: () => string | undefined;
  isPreviewMode?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  logoUrl,
  gameTitle,
  platforms,
  supportedLanguages,
  currentLanguage,
  onLanguageChange,
  onClickMyTickets,
  horizontalPadding,
  showHeader = true,
  showMainHeader = true,
  showSubHeader = true,
  showHeaderLogo = true,
  mainHeaderBgColor,
  subHeaderBgColor,
  subHeaderTextColor,
  mainHeaderTextColor,
  changeTheme,
  myTicketsButtonText,
  loginButtonText,
  logoWidth,
  // targetUrl,
  onClickLandingPageButton,
  secondaryAccentColor,
  headerTextColors,
  onButtonClick,
  color,
  buttonBgColor,
  contactUsButtonText,
  unreadMessageCount,
  myTicketsHref,
  landingPageHref,
  contactUsHref,
  isPreviewMode,
}) => {
  return (
    <Box>
      {
        /* Main Header Section */
        showHeader && showMainHeader && (
          <MainHeader
            changeTheme={changeTheme}
            showHeaderLogo={showHeaderLogo}
            logoUrl={logoUrl}
            logoSize={logoWidth}
            gameTitle={gameTitle}
            horizontalPadding={horizontalPadding}
            marginStart={{ base: '7%', lg: '5%' }}
            mainHeaderBgColor={mainHeaderBgColor}
            mainHeaderTextColor={mainHeaderTextColor}
            loginButtonText={loginButtonText}
            // logoWidth={logoWidth}
            onClickLandingPageButton={onClickLandingPageButton}
            landingPageHref={landingPageHref}
            onClickMainHeading={onClickLandingPageButton}
            // targetUrl={targetUrl}
            platforms={platforms}
            // currentLanguage={currentLanguage}
            // supportedLanguages={supportedLanguages}
            // onLanguageChange={onLanguageChange}
            secondaryAccentColor={secondaryAccentColor}
            headerTextColors={headerTextColors}
            onButtonClick={onButtonClick}
            color={color}
            buttonBgColor={buttonBgColor}
            contactUsButtonText={contactUsButtonText}
            contactUsHref={contactUsHref}
            isPreviewMode={isPreviewMode}
          />
        )
      }
      <Box position="relative">
        {showHeader && showSubHeader && (
          <Box
            position="absolute"
            left={0}
            right={0}
            zIndex={10}
            height={{ base: '60px', md: '70px', lg: '80px' }}
          >
            <SubHeader
              textColor={subHeaderTextColor}
              horizontalPadding={horizontalPadding}
              subHeaderBgColor={subHeaderBgColor}
              subHeaderTextColor={headerTextColors}
              onClickMyTickets={onClickMyTickets}
              myTicketsButtonText={myTicketsButtonText}
              secondaryAccentColor={secondaryAccentColor}
              currentLanguage={currentLanguage}
              supportedLanguages={supportedLanguages}
              onLanguageChange={onLanguageChange}
              unreadMessageCount={unreadMessageCount}
              myTicketsHref={myTicketsHref}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
